// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.who-capsule {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  width: 100%;
  text-align: left;
}

.who-capsule__card {
  --who-ink: #1b2a32;
  --who-muted: #4a5d66;
  --who-line: rgba(27, 42, 50, 0.08);
  border-radius: 16px;
  padding: 0.9rem 1rem 1rem;
  background: linear-gradient(165deg, #f4fbf8 0%, #eef6fb 55%, #f7f3ee 100%);
  border: 1px solid rgba(29, 138, 120, 0.14);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.7) inset,
    0 8px 22px -12px rgba(27, 42, 50, 0.16);
}

.who-capsule--dark .who-capsule__card {
  --who-ink: #f4f7f8;
  --who-muted: rgba(226, 232, 240, 0.8);
  --who-line: rgba(255, 255, 255, 0.08);
  background: linear-gradient(165deg, rgba(29, 138, 120, 0.18) 0%, rgba(91, 77, 179, 0.12) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: none;
}

.who-capsule__eyebrow {
  margin: 0 0 0.2rem;
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #1d8a78;
}

.who-capsule--dark .who-capsule__eyebrow {
  color: #7ee0ce;
}

.who-capsule__title {
  margin: 0 0 0.4rem;
  font-size: 0.98rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--who-ink);
}

.who-capsule__rec {
  margin: 0 0 0.65rem;
  font-size: 0.82rem;
  line-height: 1.45;
  color: var(--who-muted);
}

.who-capsule__benefits-label {
  margin: 0 0 0.35rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--who-muted);
}

.who-capsule__benefits {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin: 0;
  padding: 0;
}

.who-capsule__benefits li {
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.25;
  padding: 0.28rem 0.55rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  color: var(--who-ink);
}

.who-capsule--dark .who-capsule__benefits li {
  background: rgba(15, 23, 42, 0.35);
}

.who-capsule--compact .who-capsule__rec {
  font-size: 0.78rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ScforhWhoCapsule.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,mBAAmB;EACnB,yBAAyB;EACzB,0EAA0E;EAC1E,0CAA0C;EAC1C;;2CAEyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,8FAA8F;EAC9F,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".who-capsule {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  width: 100%;\n  text-align: left;\n}\n\n.who-capsule__card {\n  --who-ink: #1b2a32;\n  --who-muted: #4a5d66;\n  --who-line: rgba(27, 42, 50, 0.08);\n  border-radius: 16px;\n  padding: 0.9rem 1rem 1rem;\n  background: linear-gradient(165deg, #f4fbf8 0%, #eef6fb 55%, #f7f3ee 100%);\n  border: 1px solid rgba(29, 138, 120, 0.14);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.7) inset,\n    0 8px 22px -12px rgba(27, 42, 50, 0.16);\n}\n\n.who-capsule--dark .who-capsule__card {\n  --who-ink: #f4f7f8;\n  --who-muted: rgba(226, 232, 240, 0.8);\n  --who-line: rgba(255, 255, 255, 0.08);\n  background: linear-gradient(165deg, rgba(29, 138, 120, 0.18) 0%, rgba(91, 77, 179, 0.12) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: none;\n}\n\n.who-capsule__eyebrow {\n  margin: 0 0 0.2rem;\n  font-size: 0.64rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #1d8a78;\n}\n\n.who-capsule--dark .who-capsule__eyebrow {\n  color: #7ee0ce;\n}\n\n.who-capsule__title {\n  margin: 0 0 0.4rem;\n  font-size: 0.98rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--who-ink);\n}\n\n.who-capsule__rec {\n  margin: 0 0 0.65rem;\n  font-size: 0.82rem;\n  line-height: 1.45;\n  color: var(--who-muted);\n}\n\n.who-capsule__benefits-label {\n  margin: 0 0 0.35rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--who-muted);\n}\n\n.who-capsule__benefits {\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin: 0;\n  padding: 0;\n}\n\n.who-capsule__benefits li {\n  font-size: 0.72rem;\n  font-weight: 600;\n  line-height: 1.25;\n  padding: 0.28rem 0.55rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.72);\n  color: var(--who-ink);\n}\n\n.who-capsule--dark .who-capsule__benefits li {\n  background: rgba(15, 23, 42, 0.35);\n}\n\n.who-capsule--compact .who-capsule__rec {\n  font-size: 0.78rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
